module.exports = __webpack_public_path__ + "img/058bd59.png";